import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Type } from '@uswitch/spark.type';
import { getVariantPath, ToggleRevealItemContext } from '@uswitch/spark.utils';
import { MdAdd, MdRemove } from '@uswitch/spark-icons/md';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
var resetButtonStyles = {
  border: 0,
  borderRadius: 0,
  bg: 'unset',
  color: 'inherit',
  display: 'block',
  textAlign: 'inherit'
};
var accordionButtonVariantPath = getVariantPath({
  id: 'accordion',
  element: 'accordionButton'
});
var accordionIconVariantPath = getVariantPath({
  id: 'accordion',
  element: 'accordionIcon'
})();

var AccordionIcon = function AccordionIcon(_ref) {
  var isOpen = _ref.isOpen,
      props = _objectWithoutProperties(_ref, ["isOpen"]);

  return isOpen ? _jsx(MdRemove, _objectSpread({}, props)) : _jsx(MdAdd, _objectSpread({}, props));
};

var AccordionButton = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var IconElement = _ref2.iconElement,
      extraPadding = _ref2.extraPadding,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["iconElement", "extraPadding", "children"]);

  var _useContext = useContext(ToggleRevealItemContext),
      isOpen = _useContext.isOpen,
      handleToggle = _useContext.handleToggle;

  return _jsx(Type.Body1, {
    as: "h2",
    "data-spark-accordion-open": isOpen,
    "data-spark-accordion-button": true,
    "aria-expanded": isOpen,
    sx: {
      my: 0
    },
    children: _jsxs(Type.Button1, _objectSpread(_objectSpread({
      as: "button",
      ref: ref,
      onClick: handleToggle,
      sx: _objectSpread(_objectSpread({}, resetButtonStyles), {}, {
        cursor: 'pointer',
        px: extraPadding ? 'sm' : 0,
        py: 'sm',
        mb: 0,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        variant: accordionButtonVariantPath(),
        '&:hover, ._force-hover &': {
          variant: accordionButtonVariantPath('base', 'hover')
        },
        '&:focus, ._force-focus &': {
          variant: accordionButtonVariantPath('base', 'focus')
        }
      })
    }, props), {}, {
      children: [children, IconElement ? _jsx(IconElement, {
        isOpen: isOpen,
        sx: {
          ml: 'auto',
          variant: accordionIconVariantPath,
          width: '24px',
          height: '24px'
        }
      }) : 'noIcon']
    }))
  });
});
AccordionButton.displayName = 'AccordionButton';
AccordionButton.propTypes = {
  /**
   * The element type of the icon, this component optionally takes a props `isOpen` to change between icons
   */
  iconElement: PropTypes.elementType
};
AccordionButton.defaultProps = {
  iconElement: AccordionIcon,
  extraPadding: false
};
export { AccordionButton };